<template>
    <v-container>
      <div>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" justify="center">
            <p class="header-title"> {{$t('size_manager.title')}} </p>
          </v-col>

          <v-col cols="12" sm="6" justify="center" class="pr-5">
            <v-row class="d-flex justify-end">
              <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                  </template>
                  <v-card>
                      <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                          <v-container>
                            <v-row no-gutters>
                              <v-col>
                                  <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('size_manager.name')" outlined dense></v-text-field>
                              </v-col>
                            </v-row>
                            
                            <v-row no-gutters>
                              <v-col>
                                  <v-text-field v-model="editedItem.description" v-bind:label="$t('size_manager.description')" outlined dense></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row no-gutters>
                              <v-col>
                                  <v-text-field v-model="editedItem.weight" type="number" :rules="stringRules" v-bind:label="$t('size_manager.order')" min="0" outlined dense></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                      </v-card-text>

                      <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" dark @click="close">{{ $t('common.cancel')}}</v-btn>
                          <v-btn color="primary" dark @click="save">{{ $t('common.save')}}</v-btn>
                      </v-card-actions>
                  </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="order" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
          <template v-slot:top>
            <v-toolbar flat color="white" class="pt-5">
              <v-row justify="start">
                <v-col cols="12" sm="1">
                  <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="2">
                </v-col>
                
                <v-col cols="12" sm="2">
                </v-col>

                <v-col cols="12" sm="7">
                  <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

          <template v-slot:[`item.action`]="{ item }">
              <v-icon  small class="mr-2"  @click="editItem(item)">
                  edit
              </v-icon>
              <v-icon  small @click="deleteItem(item)">
                  delete
              </v-icon>

          </template>

          <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
          </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
       
        { text: i18n.t('size_manager.name'), sortable: false, value: 'name' },
        { text: i18n.t('size_manager.description'), sortable: false, value: 'description' },
        { text: i18n.t('size_manager.order'), value: 'weight' },

        { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      stringRules: [
          v => !!v || i18n.t('validate.not_empty')
      ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('print_style.add') : i18n.t('print_style.edit')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.getData()
    },

    methods: {
      initialize () {
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete("/sizeLabel/" + item._id);
          if(response.data && response.data.success) {
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        const self = this;
        if (!this.editedItem.name || this.editedItem.name.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (!this.editedItem.weight || this.editedItem.weight.length == 0) {
          alert(i18n.t('validate.infor_empty'));
          return;
        }

        if (this.editedIndex > -1) {
          try {
            const requestBody =  self.editedItem;
            const response = await this.$http.put('/sizeLabel/' + self.editedItem._id,  requestBody);

            if (response.data && response.data.success) {
                Object.assign(this.desserts[this.editedIndex], this.editedItem);
                self.editedItem = {};

                this.$fire({
                    title: i18n.t('common.update_success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            }
          } catch (e) {
              console.log(e.stack);
          }
        } else {
          try {
            const requestBody = self.editedItem;
            const response = await this.$http.post('/sizeLabel', requestBody);

            if (response.data && response.data.success) {
                self.editedItem._id = response.data.data.id;
                
                this.desserts.push(self.editedItem);
                self.editedItem.index = this.desserts.length;
                self.editedItem = {};

                this.$fire({
                  title: i18n.t('common.success'),
                  text: "",
                  type: "success"
                  }).then(() => {
                        
                });
            }
          } catch (e) {
              console.log(e.stack);
          }
        }
        this.close()
      },

      async getData() {
        try {
            const response = await this.$http.get('/sizeLabel');
            if (response.data && response.data.success) {
              const contextArr = response.data.data;
              contextArr.forEach((item, index) =>item.index = index + 1);

              this.desserts = contextArr;
              this.loading = false;
            }
        } catch (e) {
            console.log(e.stack);
        }
      }
    },
  }
</script>